import { useState, useEffect } from "react";
import { inspirationImages } from "../data/inspirationData.js";

export default function InspirationModal({ info, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const { handle, design } = info ?? {};
  const key = handle === "none" ? "gola" : "handles";
  const images = info?.dynamic
    ? (info.productConfig?.media?.inspirations ?? []).map((item) => item.url)
    : inspirationImages[design?.id]?.[key] ?? [];

  function navigate(dir) {
    setCurrentIndex((i) => (i + dir + images.length) % images.length);
  }

  useEffect(() => {
    setCurrentIndex(0);
  }, [design?.id, handle]);

  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") navigate(-1);
      if (e.key === "ArrowRight") navigate(1);
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [images.length, onClose]);

  if (!info || images.length === 0) return null;

  return (
    <div
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 md:p-6"
      onClick={onClose}
    >
      <div
        className="relative bg-white rounded-4xl md:rounded-[40px] w-full max-w-[90vw] md:max-w-5xl p-6 md:p-10 flex flex-col gap-4"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Left arrow */}
        {images.length > 1 && (
          <button
            onClick={() => navigate(-1)}
            className="absolute left-3 md:left-5 top-1/2 -translate-y-1/2 text-6xl md:text-7xl text-gray-400 hover:text-gray-700 transition-colors select-none leading-none"
          >
            &#8249;
          </button>
        )}

        {/* Image */}
        <div className="flex items-center justify-center min-h-[40vh] md:min-h-[55vh] px-8 md:px-12">
          <img
            key={images[currentIndex]}
            src={images[currentIndex]}
            alt=""
            draggable={false}
            className="block max-w-full max-h-[40vh] md:max-h-[55vh] select-none"
          />
        </div>

        {/* Dots */}
        {images.length > 1 && (
          <div className="flex justify-center items-center gap-2 min-h-5">
            {images.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrentIndex(i)}
                className={`w-2 h-2 rounded-full transition-colors ${
                  i === currentIndex
                    ? "bg-gray-800"
                    : "bg-gray-300 hover:bg-gray-400"
                }`}
              />
            ))}
          </div>
        )}

        {/* Right arrow */}
        {images.length > 1 && (
          <button
            onClick={() => navigate(1)}
            className="absolute right-3 md:right-5 top-1/2 -translate-y-1/2 text-6xl md:text-7xl text-gray-400 hover:text-gray-700 transition-colors select-none leading-none"
          >
            &#8250;
          </button>
        )}
      </div>
    </div>
  );
}
